import { GetDamagedCustomerVehicleImagesQueryParamsType } from '@/modules/adjusterReportModules/IncidentParticipants/queries/getDamagedCustomerVehicleImages/getDamagedCustomerVehicleImagesQuery.type';
import { getDamagedCustomerVehicleImagesFunction } from '@/modules/adjusterReportModules/IncidentParticipants/queries/getDamagedCustomerVehicleImages/getDamagedCustomerVehicleImagesQueryFunction';
import { queryOptions } from '@tanstack/react-query';

export const getDamagedCustomerVehicleImagesQueryOptions = (
  params: GetDamagedCustomerVehicleImagesQueryParamsType,
) => {
  return queryOptions({
    queryKey: ['damagedCustomerVehicleImages', params],
    queryFn: () => getDamagedCustomerVehicleImagesFunction(params),
    enabled: true,
  });
};
